import { NgModule } from '@angular/core';
import { NotfoundComponent } from 'app/pages/notfound/notfound.component';
import { LoginComponent } from 'app/pages/login/login.component';
import { RecuperarSenhaComponent } from 'app/pages/recuperar-senha/recuperar-senha.component';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ScheduleSelectComponent } from './pages/schedule/select/schedule-select.component';
import { ScheduleAppointmentComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { ScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { PaymentRegistrationComponent } from './pages/payment/registration/payment-registration.component';
import { CalendarComponent } from './pages/schedule/calendar/calendar.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { ScheduleRegistrationComponent } from './pages/schedule/registration/schedule-registration.component';
import { AuthGuard } from './core/guards/auth.guard';
import { RegisterComponent } from './pages/registration/register.component';
import { RegisterConfirmationComponent } from './pages/registration/register-confirmation/register-confirmation.component';
import { FirstAccessGuard } from './core/guards/first-access.guard';
import { GoogleLoginComponent } from './pages/login/google-login/google-login.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { NoAuthGuard } from './core/guards/no-auth.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
  {
    path: 'criar-conta',
    component: RegisterComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'confirmar-conta',
    component: RegisterConfirmationComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'google-login',
    component: GoogleLoginComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'agenda',
    component: ScheduleSelectComponent,
    canLoad: [AuthGuard],
  },
  {
    path: 'calendario',
    component: CalendarComponent,
    canLoad: [AuthGuard],
  },
  {
    path: 'agendar',
    component: ScheduleComponent,
    canLoad: [AuthGuard],
  },
  {
    path: 'agendar/consulta',
    component: ScheduleAppointmentComponent,
    canLoad: [AuthGuard],
  },

  {
    path: 'agendamento',
    component: ScheduleRegistrationComponent,
    canLoad: [AuthGuard],
  },
  {
    path: 'agendamento/:id',
    component: ScheduleRegistrationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'agenda/status',
    component: ScheduleStatusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'metodo-pagamento/cadastro/:id',
    component: PaymentRegistrationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'metodo-pagamento/cadastro',
    component: PaymentRegistrationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'recuperar-senha',
    component: RecuperarSenhaComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'recuperar-senha/:token',
    component: RecuperarSenhaComponent,
    canActivate: [NoAuthGuard],
  },
  {
    path: 'notfound',
    component: NotfoundComponent,
    canLoad: [],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    canLoad: [],
  },
  {
    path: 'terms-of-service',
    component: TermsOfServiceComponent,
    canLoad: [],
  },
  {
    path: 'organization-new',
    loadChildren: () => import('./modules/organization/organization.module').then((m) => m.OrganizationModule),
  },
  {
    path: 'secretarias-new',
    loadChildren: () => import('./modules/secretaries/secretaries.module').then((m) => m.SecretariesModule),
  },
  {
    path: 'patient-new',
    loadChildren: () => import('./modules/patient/patient.module').then((m) => m.PatientModule),
  },
  {
    path: 'medico',
    loadChildren: () => import('./modules/practitioner/practitioner.module').then((m) => m.PractitionerModule),
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
